import { JsonObject, JsonProperty } from 'json2typescript';
import { Entity } from '@shared/entities/entity';

@JsonObject('Partner')
export class Partner extends Entity {
  @JsonProperty('accountId', String)
  public accountId?: string = undefined;

  @JsonProperty('accountName', String)
  public accountName?: string = undefined;

  @JsonProperty('lastName', String)
  public lastName?: string = undefined;

  @JsonProperty('firstName', String)
  public firstName?: string = undefined;

  @JsonProperty('name', String)
  public name?: string = undefined;

  @JsonProperty('isPartner', Boolean)
  public isPartner?: boolean = undefined;

  @JsonProperty('locationId', String)
  public locationId?: string = undefined;

  @JsonProperty('locationName', String)
  public locationName?: string = undefined;

  @JsonProperty('phone', String)
  public phone?: string = undefined;

  @JsonProperty('mobilePhone', String)
  public mobilePhone?: string = undefined;

  @JsonProperty('email', String)
  public email?: string = undefined;

  @JsonProperty('billingCity', String)
  public billingCity?: string = undefined;

  @JsonProperty('billingCountry', String)
  public billingCountry?: string = undefined;

  @JsonProperty('photoUrl', String)
  public photoUrl?: string = undefined;

  @JsonProperty('lastModifiedDate', String)
  public lastModifiedDate?: string = undefined;

  @JsonProperty('lastModifiedById', String)
  public lastModifiedById?: string = undefined;
}
